<form [formGroup]="formGroup" (submit)="onSubmit($event)">
  <h1 mat-dialog-title>{{ 'batchScanningDialog.title' | translate }}</h1>
  <mat-dialog-content>
    <p>{{ 'batchScanningDialog.text' | translate }}</p>
    <p>{{ 'batchScanningDialog.expectedAmount' | translate }} {{ expectedNumberOfItems }}</p>
    <div class="item-count-row">
      <mat-form-field appearance="outline">
        <input matNativeControl type="number" formControlName="actualNumberOfItems">
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button type="button" mat-button (click)="onCancel()">{{ 'cancel' | translate }}</button>
    <button type="button" mat-flat-button color="primary"
            [disabled]="formGroup.invalid"
            (click)="onConfirm()">{{ 'confirm' | translate  }}</button>
  </mat-dialog-actions>
</form>
